import Vue from 'vue'
import axios from 'axios'

import * as TYPE from '../util/types'
import { baseURL } from '../util/values'

// axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
// axios.defaults.xsrfCookieName = 'csrftoken'

// ********************
// EVENTS

export function postEvent(data) {
	return axios({
		method: 'post',
		url: '/api/v1/event/',
		data: data
	}).then(result => {
		return result
	})
}

export function fetchAllEvents() {
	return axios.get('/api/v1/event/?format=json')
}

export function fetchNearbyEvents(location, radius) {
	return axios
		.get(
			'/api/v1/nearbyevents/?format=json&location=' +
				location +
				'&radius=' +
				radius
		)
		.then(result => {
			return result.data
		})
}

export function fetchEventBySlug(eventSlug) {
	return axios.get('/api/v1/event/' + eventSlug + '/retrieve_by_slug/?format=json')
}

export function fetchEvent(eventId) {
	return axios('/api/v1/event/' + eventId + '/?format=json').then(result => {
		return result.data
	})
}

// ********************
// EVENT TAGS

export function fetchEventTags() {
	return axios.get('/api/v1/eventtag/?format=json').then(result => {
		return result.data
	})
}

// ********************
// LOCATIONS

export function postLocation(data) {
	return axios({
		withCredentials: true,
		method: 'post',
		url: '/api/v1/location/',
		data: data
	}).then(result => {
		return result
	})
}

export function fetchAllLocations() {
	return axios.get('/api/v1/location/?format=json')
}

export function fetchLocation(locationId) {
	let url = '/api/v1/location/' + locationId + '/?format=json'
	return axios.get(url).then(result => {
		return result.data
	})
}

export function fetchLocationPrivate(payload) {
	return axios.get(
		'/api/v1/location-private/' +
			payload.location +
			'/user/' +
			payload.user +
			'/'
		)
}

export function fetchLocationBySlug(slug) {
	return axios.get(`/api/v1/location/${slug}/slug/`)
}